<ng-template #displayTemplateRef
             let-cellData>
  @if (checkHasValue(cellData)) {
    @if (columnEnumType) {
      <p-tag [value]="cellData | enumLocalize: columnEnumType"
             [rounded]="true"
             [severity]="cellData | enumStyle: columnEnumType">
      </p-tag>
    } @else {
      @if (!tableColumn.enumMap) {
        <p-tag [rounded]="true"
               [value]="getCellValue(cellData)">
        </p-tag>
      }
    }
  }
</ng-template>